import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  selector: 'app-progress-spinner',
  template: `
    <div [class]="classes()" [attr.role]="'status'" [attr.aria-label]="ariaLabel()">
      <svg
        class="animate-spin"
        [attr.width]="size()"
        [attr.height]="size()"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        aria-hidden="true"
      >
        <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" [attr.stroke-width]="strokeWidth()" />
        <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" />
      </svg>
      <span class="sr-only">{{ ariaLabel() }}</span>
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class UiProgressSpinner {
  readonly size = input<string>('24');
  readonly strokeWidth = input<string>('4');
  readonly color = input<string>('text-accent-600');
  readonly ariaLabel = input<string>('Cargando...');

  protected classes(): string {
    return `inline-flex items-center justify-center ${this.color()}`;
  }
}
